"use strict";
// Generated from src/parser/Algebrain.g4 by ANTLR 4.7.3-SNAPSHOT
Object.defineProperty(exports, "__esModule", { value: true });
const ATNDeserializer_1 = require("antlr4ts/atn/ATNDeserializer");
const Lexer_1 = require("antlr4ts/Lexer");
const LexerATNSimulator_1 = require("antlr4ts/atn/LexerATNSimulator");
const VocabularyImpl_1 = require("antlr4ts/VocabularyImpl");
const Utils = require("antlr4ts/misc/Utils");
class AlgebrainLexer extends Lexer_1.Lexer {
    // tslint:enable:no-trailing-whitespace
    constructor(input) {
        super(input);
        this._interp = new LexerATNSimulator_1.LexerATNSimulator(AlgebrainLexer._ATN, this);
    }
    // @Override
    // @NotNull
    get vocabulary() {
        return AlgebrainLexer.VOCABULARY;
    }
    // @Override
    get grammarFileName() {
        return 'Algebrain.g4';
    }
    // @Override
    get ruleNames() {
        return AlgebrainLexer.ruleNames;
    }
    // @Override
    get serializedATN() {
        return AlgebrainLexer._serializedATN;
    }
    // @Override
    get channelNames() {
        return AlgebrainLexer.channelNames;
    }
    // @Override
    get modeNames() {
        return AlgebrainLexer.modeNames;
    }
    static get _ATN() {
        if (!AlgebrainLexer.__ATN) {
            AlgebrainLexer.__ATN = new ATNDeserializer_1.ATNDeserializer().deserialize(Utils.toCharArray(AlgebrainLexer._serializedATN));
        }
        return AlgebrainLexer.__ATN;
    }
}
AlgebrainLexer.REWRITABLE_PREFIX = 1;
AlgebrainLexer.SPACE = 2;
AlgebrainLexer.COMMAND = 3;
AlgebrainLexer.TRUE = 4;
AlgebrainLexer.FALSE = 5;
AlgebrainLexer.IF = 6;
AlgebrainLexer.AND = 7;
AlgebrainLexer.OR = 8;
AlgebrainLexer.ID = 9;
AlgebrainLexer.POINT = 10;
AlgebrainLexer.COLON = 11;
AlgebrainLexer.NOT = 12;
AlgebrainLexer.NUMBER = 13;
AlgebrainLexer.POW = 14;
AlgebrainLexer.MUL = 15;
AlgebrainLexer.DIV = 16;
AlgebrainLexer.PLUS = 17;
AlgebrainLexer.MINUS = 18;
AlgebrainLexer.LPAREN = 19;
AlgebrainLexer.RPAREN = 20;
AlgebrainLexer.LSQPAREN = 21;
AlgebrainLexer.RSQPAREN = 22;
AlgebrainLexer.COMMA = 23;
AlgebrainLexer.EQUALS = 24;
AlgebrainLexer.NEWLINE = 25;
AlgebrainLexer.WS = 26;
// tslint:disable:no-trailing-whitespace
AlgebrainLexer.channelNames = ['DEFAULT_TOKEN_CHANNEL', 'HIDDEN'];
// tslint:disable:no-trailing-whitespace
AlgebrainLexer.modeNames = ['DEFAULT_MODE'];
AlgebrainLexer.ruleNames = [
    'REWRITABLE_PREFIX',
    'SPACE',
    'COMMAND',
    'TRUE',
    'FALSE',
    'IF',
    'AND',
    'OR',
    'ID',
    'POINT',
    'COLON',
    'NOT',
    'NUMBER',
    'POW',
    'MUL',
    'DIV',
    'PLUS',
    'MINUS',
    'LPAREN',
    'RPAREN',
    'LSQPAREN',
    'RSQPAREN',
    'COMMA',
    'EQUALS',
    'NEWLINE',
    'WS',
];
AlgebrainLexer._LITERAL_NAMES = [
    undefined,
    "'$'",
    "' '",
    undefined,
    "'true'",
    "'false'",
    "'if'",
    "'and'",
    "'or'",
    undefined,
    "'.'",
    "':'",
    "'not'",
    undefined,
    "'^'",
    "'*'",
    "'/'",
    "'+'",
    "'-'",
    "'('",
    "')'",
    "'['",
    "']'",
    "','",
    "'='",
];
AlgebrainLexer._SYMBOLIC_NAMES = [
    undefined,
    'REWRITABLE_PREFIX',
    'SPACE',
    'COMMAND',
    'TRUE',
    'FALSE',
    'IF',
    'AND',
    'OR',
    'ID',
    'POINT',
    'COLON',
    'NOT',
    'NUMBER',
    'POW',
    'MUL',
    'DIV',
    'PLUS',
    'MINUS',
    'LPAREN',
    'RPAREN',
    'LSQPAREN',
    'RSQPAREN',
    'COMMA',
    'EQUALS',
    'NEWLINE',
    'WS',
];
AlgebrainLexer.VOCABULARY = new VocabularyImpl_1.VocabularyImpl(AlgebrainLexer._LITERAL_NAMES, AlgebrainLexer._SYMBOLIC_NAMES, []);
AlgebrainLexer._serializedATN = '\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x02\x1C\xC4\b\x01' +
    '\x04\x02\t\x02\x04\x03\t\x03\x04\x04\t\x04\x04\x05\t\x05\x04\x06\t\x06' +
    '\x04\x07\t\x07\x04\b\t\b\x04\t\t\t\x04\n\t\n\x04\v\t\v\x04\f\t\f\x04\r' +
    '\t\r\x04\x0E\t\x0E\x04\x0F\t\x0F\x04\x10\t\x10\x04\x11\t\x11\x04\x12\t' +
    '\x12\x04\x13\t\x13\x04\x14\t\x14\x04\x15\t\x15\x04\x16\t\x16\x04\x17\t' +
    '\x17\x04\x18\t\x18\x04\x19\t\x19\x04\x1A\t\x1A\x04\x1B\t\x1B\x03\x02\x03' +
    '\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03' +
    '\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03' +
    '\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03' +
    '\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03' +
    '\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03' +
    '\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03\x04\x03' +
    '\x04\x03\x04\x03\x04\x05\x04r\n\x04\x03\x05\x03\x05\x03\x05\x03\x05\x03' +
    '\x05\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06\x03\x07\x03\x07\x03' +
    '\x07\x03\b\x03\b\x03\b\x03\b\x03\t\x03\t\x03\t\x03\n\x06\n\x8A\n\n\r\n' +
    '\x0E\n\x8B\x03\v\x03\v\x03\f\x03\f\x03\r\x03\r\x03\r\x03\r\x03\x0E\x06' +
    '\x0E\x97\n\x0E\r\x0E\x0E\x0E\x98\x03\x0E\x03\x0E\x06\x0E\x9D\n\x0E\r\x0E' +
    '\x0E\x0E\x9E\x05\x0E\xA1\n\x0E\x03\x0F\x03\x0F\x03\x10\x03\x10\x03\x11' +
    '\x03\x11\x03\x12\x03\x12\x03\x13\x03\x13\x03\x14\x03\x14\x03\x15\x03\x15' +
    '\x03\x16\x03\x16\x03\x17\x03\x17\x03\x18\x03\x18\x03\x19\x03\x19\x03\x1A' +
    '\x05\x1A\xBA\n\x1A\x03\x1A\x03\x1A\x03\x1B\x06\x1B\xBF\n\x1B\r\x1B\x0E' +
    '\x1B\xC0\x03\x1B\x03\x1B\x02\x02\x02\x1C\x03\x02\x03\x05\x02\x04\x07\x02' +
    '\x05\t\x02\x06\v\x02\x07\r\x02\b\x0F\x02\t\x11\x02\n\x13\x02\v\x15\x02' +
    '\f\x17\x02\r\x19\x02\x0E\x1B\x02\x0F\x1D\x02\x10\x1F\x02\x11!\x02\x12' +
    "#\x02\x13%\x02\x14'\x02\x15)\x02\x16+\x02\x17-\x02\x18/\x02\x191\x02" +
    '\x1A3\x02\x1B5\x02\x1C\x03\x02\x05\x05\x02C\\aac|\x03\x022;\x04\x02\v' +
    '\v""\x02\xD0\x02\x03\x03\x02\x02\x02\x02\x05\x03\x02\x02\x02\x02\x07' +
    '\x03\x02\x02\x02\x02\t\x03\x02\x02\x02\x02\v\x03\x02\x02\x02\x02\r\x03' +
    '\x02\x02\x02\x02\x0F\x03\x02\x02\x02\x02\x11\x03\x02\x02\x02\x02\x13\x03' +
    '\x02\x02\x02\x02\x15\x03\x02\x02\x02\x02\x17\x03\x02\x02\x02\x02\x19\x03' +
    '\x02\x02\x02\x02\x1B\x03\x02\x02\x02\x02\x1D\x03\x02\x02\x02\x02\x1F\x03' +
    '\x02\x02\x02\x02!\x03\x02\x02\x02\x02#\x03\x02\x02\x02\x02%\x03\x02\x02' +
    "\x02\x02'\x03\x02\x02\x02\x02)\x03\x02\x02\x02\x02+\x03\x02\x02\x02\x02" +
    '-\x03\x02\x02\x02\x02/\x03\x02\x02\x02\x021\x03\x02\x02\x02\x023\x03\x02' +
    '\x02\x02\x025\x03\x02\x02\x02\x037\x03\x02\x02\x02\x059\x03\x02\x02\x02' +
    '\x07q\x03\x02\x02\x02\ts\x03\x02\x02\x02\vx\x03\x02\x02\x02\r~\x03\x02' +
    '\x02\x02\x0F\x81\x03\x02\x02\x02\x11\x85\x03\x02\x02\x02\x13\x89\x03\x02' +
    '\x02\x02\x15\x8D\x03\x02\x02\x02\x17\x8F\x03\x02\x02\x02\x19\x91\x03\x02' +
    '\x02\x02\x1B\x96\x03\x02\x02\x02\x1D\xA2\x03\x02\x02\x02\x1F\xA4\x03\x02' +
    '\x02\x02!\xA6\x03\x02\x02\x02#\xA8\x03\x02\x02\x02%\xAA\x03\x02\x02\x02' +
    "'\xAC\x03\x02\x02\x02)\xAE\x03\x02\x02\x02+\xB0\x03\x02\x02\x02-\xB2" +
    '\x03\x02\x02\x02/\xB4\x03\x02\x02\x021\xB6\x03\x02\x02\x023\xB9\x03\x02' +
    '\x02\x025\xBE\x03\x02\x02\x0278\x07&\x02\x028\x04\x03\x02\x02\x029:\x07' +
    '"\x02\x02:\x06\x03\x02\x02\x02;<\x07v\x02\x02<=\x07t\x02\x02=>\x07c\x02' +
    '\x02>?\x07p\x02\x02?@\x07u\x02\x02@A\x07h\x02\x02AB\x07q\x02\x02BC\x07' +
    't\x02\x02Cr\x07o\x02\x02DE\x07g\x02\x02EF\x07x\x02\x02FG\x07c\x02\x02' +
    'GH\x07n\x02\x02HI\x07w\x02\x02IJ\x07c\x02\x02JK\x07v\x02\x02Kr\x07g\x02' +
    '\x02LM\x07t\x02\x02MN\x07w\x02\x02NO\x07n\x02\x02OP\x07g\x02\x02Pr\x07' +
    'u\x02\x02QR\x07j\x02\x02RS\x07g\x02\x02ST\x07n\x02\x02Tr\x07r\x02\x02' +
    'UV\x07v\x02\x02VW\x07t\x02\x02WX\x07g\x02\x02Xr\x07g\x02\x02YZ\x07v\x02' +
    '\x02Z[\x07t\x02\x02[\\\x07c\x02\x02\\]\x07p\x02\x02]^\x07u\x02\x02^_\x07' +
    'h\x02\x02_`\x07q\x02\x02`a\x07t\x02\x02ab\x07o\x02\x02bc\x07c\x02\x02' +
    'cd\x07v\x02\x02de\x07k\x02\x02ef\x07q\x02\x02fg\x07p\x02\x02gr\x07u\x02' +
    '\x02hi\x07w\x02\x02ij\x07u\x02\x02jr\x07g\x02\x02kl\x07c\x02\x02lm\x07' +
    'e\x02\x02mn\x07v\x02\x02no\x07k\x02\x02op\x07x\x02\x02pr\x07g\x02\x02' +
    'q;\x03\x02\x02\x02qD\x03\x02\x02\x02qL\x03\x02\x02\x02qQ\x03\x02\x02\x02' +
    'qU\x03\x02\x02\x02qY\x03\x02\x02\x02qh\x03\x02\x02\x02qk\x03\x02\x02\x02' +
    'r\b\x03\x02\x02\x02st\x07v\x02\x02tu\x07t\x02\x02uv\x07w\x02\x02vw\x07' +
    'g\x02\x02w\n\x03\x02\x02\x02xy\x07h\x02\x02yz\x07c\x02\x02z{\x07n\x02' +
    '\x02{|\x07u\x02\x02|}\x07g\x02\x02}\f\x03\x02\x02\x02~\x7F\x07k\x02\x02' +
    '\x7F\x80\x07h\x02\x02\x80\x0E\x03\x02\x02\x02\x81\x82\x07c\x02\x02\x82' +
    '\x83\x07p\x02\x02\x83\x84\x07f\x02\x02\x84\x10\x03\x02\x02\x02\x85\x86' +
    '\x07q\x02\x02\x86\x87\x07t\x02\x02\x87\x12\x03\x02\x02\x02\x88\x8A\t\x02' +
    '\x02\x02\x89\x88\x03\x02\x02\x02\x8A\x8B\x03\x02\x02\x02\x8B\x89\x03\x02' +
    '\x02\x02\x8B\x8C\x03\x02\x02\x02\x8C\x14\x03\x02\x02\x02\x8D\x8E\x070' +
    '\x02\x02\x8E\x16\x03\x02\x02\x02\x8F\x90\x07<\x02\x02\x90\x18\x03\x02' +
    '\x02\x02\x91\x92\x07p\x02\x02\x92\x93\x07q\x02\x02\x93\x94\x07v\x02\x02' +
    '\x94\x1A\x03\x02\x02\x02\x95\x97\t\x03\x02\x02\x96\x95\x03\x02\x02\x02' +
    '\x97\x98\x03\x02\x02\x02\x98\x96\x03\x02\x02\x02\x98\x99\x03\x02\x02\x02' +
    '\x99\xA0\x03\x02\x02\x02\x9A\x9C\x05\x15\v\x02\x9B\x9D\t\x03\x02\x02\x9C' +
    '\x9B\x03\x02\x02\x02\x9D\x9E\x03\x02\x02\x02\x9E\x9C\x03\x02\x02\x02\x9E' +
    '\x9F\x03\x02\x02\x02\x9F\xA1\x03\x02\x02\x02\xA0\x9A\x03\x02\x02\x02\xA0' +
    '\xA1\x03\x02\x02\x02\xA1\x1C\x03\x02\x02\x02\xA2\xA3\x07`\x02\x02\xA3' +
    '\x1E\x03\x02\x02\x02\xA4\xA5\x07,\x02\x02\xA5 \x03\x02\x02\x02\xA6\xA7' +
    '\x071\x02\x02\xA7"\x03\x02\x02\x02\xA8\xA9\x07-\x02\x02\xA9$\x03\x02' +
    '\x02\x02\xAA\xAB\x07/\x02\x02\xAB&\x03\x02\x02\x02\xAC\xAD\x07*\x02\x02' +
    '\xAD(\x03\x02\x02\x02\xAE\xAF\x07+\x02\x02\xAF*\x03\x02\x02\x02\xB0\xB1' +
    '\x07]\x02\x02\xB1,\x03\x02\x02\x02\xB2\xB3\x07_\x02\x02\xB3.\x03\x02\x02' +
    '\x02\xB4\xB5\x07.\x02\x02\xB50\x03\x02\x02\x02\xB6\xB7\x07?\x02\x02\xB7' +
    '2\x03\x02\x02\x02\xB8\xBA\x07\x0F\x02\x02\xB9\xB8\x03\x02\x02\x02\xB9' +
    '\xBA\x03\x02\x02\x02\xBA\xBB\x03\x02\x02\x02\xBB\xBC\x07\f\x02\x02\xBC' +
    '4\x03\x02\x02\x02\xBD\xBF\t\x04\x02\x02\xBE\xBD\x03\x02\x02\x02\xBF\xC0' +
    '\x03\x02\x02\x02\xC0\xBE\x03\x02\x02\x02\xC0\xC1\x03\x02\x02\x02\xC1\xC2' +
    '\x03\x02\x02\x02\xC2\xC3\b\x1B\x02\x02\xC36\x03\x02\x02\x02\n\x02q\x8B' +
    '\x98\x9E\xA0\xB9\xC0\x03\b\x02\x02';
exports.AlgebrainLexer = AlgebrainLexer;
//# sourceMappingURL=AlgebrainLexer.js.map